import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;
const base = "/utility-record";

// ── Electricity Rate Configs ──────────────────────────────────────────────────

export const getElecRateConfigs = (params = "") =>
  instance({ baseURL }).get(`${base}/electricity/rate-configs${params}`);

export const getElecRateConfigById = (id) =>
  instance({ baseURL }).get(`${base}/electricity/rate-configs/${id}`);

export const createElecRateConfig = (body) =>
  instance({ baseURL }).post(`${base}/electricity/rate-configs`, body);

export const updateElecRateConfig = (id, body) =>
  instance({ baseURL }).put(`${base}/electricity/rate-configs/${id}`, body);

// ── Electricity Records ───────────────────────────────────────────────────────

export const getElecRecords = (params = "") =>
  instance({ baseURL }).get(`${base}/electricity/records${params}`);

export const getElecRecordById = (id) =>
  instance({ baseURL }).get(`${base}/electricity/records/${id}`);

export const createElecRecord = (body) =>
  instance({ baseURL }).post(`${base}/electricity/records`, body);

export const createElecRecordsBatch = (body) =>
  instance({ baseURL }).post(`${base}/electricity/records/batch`, body);

export const updateElecRecord = (id, body) =>
  instance({ baseURL }).put(`${base}/electricity/records/${id}`, body);

export const deleteElecRecord = (id) =>
  instance({ baseURL }).delete(`${base}/electricity/records/${id}`);

export const updateElecRecordStatus = (id, body) =>
  instance({ baseURL }).patch(`${base}/electricity/records/${id}/status`, body);

export const getElecRecordSummaryText = (id) =>
  instance({ baseURL }).get(`${base}/electricity/records/${id}/summary-text`);

export const compareElecRecords = (params = "") =>
  instance({ baseURL }).get(`${base}/electricity/records/compare${params}`);

export const calculateElecPreview = (body) =>
  instance({ baseURL }).post(`${base}/electricity/calculate-preview`, body);

export const getElecUnitContext = (unitId) =>
  instance({ baseURL }).get(`${base}/electricity/unit-context/${unitId}`);

export const getElecPendingSchedule = (buildingId) =>
  instance({ baseURL }).get(`${base}/electricity/pending-schedule/${buildingId}`);

// ── Water Rate Configs ────────────────────────────────────────────────────────

export const getWaterRateConfigs = (params = "") =>
  instance({ baseURL }).get(`${base}/water/rate-configs${params}`);

export const getWaterRateConfigById = (id) =>
  instance({ baseURL }).get(`${base}/water/rate-configs/${id}`);

export const createWaterRateConfig = (body) =>
  instance({ baseURL }).post(`${base}/water/rate-configs`, body);

export const updateWaterRateConfig = (id, body) =>
  instance({ baseURL }).put(`${base}/water/rate-configs/${id}`, body);

// ── Water Records ─────────────────────────────────────────────────────────────

export const getWaterPendingSchedule = (contractId) =>
  instance({ baseURL }).get(`${base}/water/pending-schedule/${contractId}`);

export const getWaterUnitContext = (unitId) =>
  instance({ baseURL }).get(`${base}/water/unit-context/${unitId}`);

export const getWaterRecords = (params = "") =>
  instance({ baseURL }).get(`${base}/water/records${params}`);

export const getWaterRecordById = (id) =>
  instance({ baseURL }).get(`${base}/water/records/${id}`);

export const createWaterRecord = (body) =>
  instance({ baseURL }).post(`${base}/water/records`, body);

export const createWaterRecordsBatch = (body) =>
  instance({ baseURL }).post(`${base}/water/records/batch`, body);

export const updateWaterRecord = (id, body) =>
  instance({ baseURL }).put(`${base}/water/records/${id}`, body);

export const deleteWaterRecord = (id) =>
  instance({ baseURL }).delete(`${base}/water/records/${id}`);

export const updateWaterRecordStatus = (id, body) =>
  instance({ baseURL }).patch(`${base}/water/records/${id}/status`, body);

export const calculateWaterPreview = (body) =>
  instance({ baseURL }).post(`${base}/water/calculate-preview`, body);
